import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import fetch from "isomorphic-fetch";
import db from '../dbconn';
import {API_ROOT} from './../api-config';
import Modal from 'react-responsive-modal';
import {IMAGE_ROOT} from "../api-config";
import {withTranslation} from 'react-i18next';
import i18n from "i18next";

import Notifications, {notify} from 'react-notify-toast';
import Swal from "sweetalert2";
import Language from "./language";


class view_product extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
            nosessionredirect: false,
            cartredirect: false,
            windowHeight: 0,
            productId: 0,
            type: "",
            quantity: 1,
            open: false,
            displayList: [],
            backUrl: "",
            multiselectList: [],
            dropdownList: [],
            productData: [],
            selectedOptions: [],
            swalButton: '',
            selectedMod: [],
            loyalty: "N",
            showBuildItem: false,
            backToHomeFlag: false,
            notes: '',
            notesEnabled: 'N'

        };


    };

    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };


    componentWillMount() {
        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });
        this.setState({
            swalButton: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'link_button'
                },
                buttonsStyling: false,
            })
        });

        var url = '';

        var product_id = sessionStorage.getItem("product_id");

        var quantity = sessionStorage.getItem("quantity");

        var type = sessionStorage.getItem("type");
        var loyalty = sessionStorage.getItem("loyalty");


        this.setState({productId: product_id});
        this.setState({quantity: quantity});
        this.setState({type: type});
        this.setState({loyalty: loyalty});


        if (sessionStorage.getItem('guestFlag') == 'Y') {
            url = API_ROOT + '/fetchproductdetails?guestFlag=Y&store_id=' + localStorage.getItem('store_id') + '&product_id=' + product_id;

            this.onOpenModal();
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(productData => {


                    this.generateProductDetails(productData);
                });
        } else {

            var dbconn = new db();

            dbconn.getAll().then(data => {
                var customer_id = data[0].customer_id;
                var customer_token = data[0].customer_token;
                url = API_ROOT + '/fetchproductdetails?guestFlag=N&store_id=' + localStorage.getItem('store_id') + '&customer_id=' + customer_id + '&customer_token=' + customer_token + '&product_id=' + product_id;

                this.onOpenModal();
                fetch(url)
                    .then(response => {
                        return response.json();
                    })
                    .then(productData => {


                        this.generateProductDetails(productData);

                    });
            });
        }


    }


    plusQuantity = (product_id) => {

        var currentVal = parseInt($('#quant_' + product_id).val());
        var newVal = 0;
        var newCartTotal = 0;

        var dbconn = new db();


        if (!isNaN(currentVal)) {

            if (currentVal < $('#quant_' + product_id).attr('max')) {
                newVal = currentVal + 1;
                $('#quant_' + product_id).val(newVal);


                this.setState({quantity: newVal});

            } else if (parseInt($('#quant_' + product_id).val()) == $('#quant_' + product_id).attr('max')) {
                $('#btn-plus_' + product_id).attr('disabled', true);
            }
        } else {
            $('#quant_' + product_id).val(0);
        }
    };


    lessQuantity = (product_id) => {

        var currentVal = parseInt($('#quant_' + product_id).val(), 10);
        var newVal = 0;

        var newCartTotal = 0;

        var dbconn = new db();


        if (!isNaN(currentVal)) {
            if (currentVal > $('#quant_' + product_id).attr('min')) {

                newVal = currentVal - 1;
                $('#quant_' + product_id).val(newVal).change();


                this.setState({quantity: newVal});


            }
            if (parseInt($('#quant_' + product_id).val(), 10) == $('#quant_' + product_id).attr('min')) {
                $('#btn-minus_' + product_id).attr('disabled', true);
            }
        } else {
            $('#quant_' + product_id).val(0);
        }
    };

    updateLabel = e => {

        /*

                var selectedOption = $(e.target).find('option:selected').text();


                $(e.target).next(".holder").text(selectedOption);

                var defaultOpt = $($(e.target).find('option:selected')).attr('data-default');
        */


        this.calTotalDropdownPrice(e);
    };


    calTotalDropdownPrice = (e) => {

        //  alert($(e.target).val());


        var optionData = this.state.dropdownList;

        for (var i = 0; i < optionData.length; i++) {


            if (optionData[i].modifier_multiselect == "N") {


                if (parseInt(optionData[i].modifier_id) == parseInt($(e.target).attr("id"))) {
                    for (var j = 0; j < optionData[i].options.length; j++) {


                        if (parseInt(optionData[i].options[j].modifier_option_id) == parseInt($(e.target).val())) {

                            optionData[i].mod_value = optionData[i].options[j].option_name;
                            optionData[i].options[j].option_selected = "Y";

                        } else {

                            optionData[i].options[j].option_selected = "N";
                        }
                    }
                }
            }
        }


        this.setState({dropdownList: optionData});


        this.calculateModifierPrice();

    };


    calTotalMultiselectPrice = e => {

        //  alert($(e.target).val());


        var optionData = this.state.dropdownList;


        for (var i = 0; i < optionData.length; i++) {

            if (optionData[i].modifier_multiselect == "Y") {


                if (parseInt(optionData[i].modifier_id) == parseInt($(e.target).attr("name").replace('mod_', ''))) {

                    for (var j = 0; j < optionData[i].options.length; j++) {


                        if (parseInt(optionData[i].options[j].modifier_option_id) == parseInt($(e.target).val())) {


                            if (optionData[i].options[j].option_selected == "Y") {


                                optionData[i].options[j].option_selected = "N";

                            } else {
                                optionData[i].options[j].option_selected = "Y";
                            }
                        }

                    }
                }
            }
        }


        this.setState({multiselectList: optionData});

        this.calculateModifierPrice();

    };


    calculateModifierPrice = () => {
        var totalModPrice = 0;
        var totalOriginalModPrice = 0;


        var optionData = this.state.dropdownList;
        for (var i = 0; i < optionData.length; i++) {

            for (var j = 0; j < optionData[i].options.length; j++) {


                if (optionData[i].options[j].option_selected == "Y") {

                    totalModPrice += parseFloat(optionData[i].options[j].option_price);
                    totalOriginalModPrice += parseFloat(optionData[i].options[j].option_original_price);

                }
            }
        }


        var productData = this.state.productData;
        productData.modifier_price = totalModPrice;
        productData.modifier_original_price = totalOriginalModPrice;
        this.setState({productData: productData});
        this.setState({totalModPrice: totalModPrice});
    };

    updateModifierText = e => {


        //console.log($(e.target).val());

        var optionData = this.state.dropdownList;

        for (var i = 0; i < optionData.length; i++) {


            if (parseInt(optionData[i].modifier_id) == parseInt($(e.target).attr("id"))) {


                optionData[i].mod_value = $(e.target).val().trim();


            }

        }

        console.log(optionData);

        this.setState({dropdownList: optionData});
        var productData = this.state.productData;
        productData.dropdown_mod = optionData;
        this.setState({productData: productData});

    };
    generateProductDetails = (productData) => {


        this.onCloseModal();

        if (productData.status == 1) {

            var modPrice = 0;
            var modOriginalPrice = 0;
            var currentArr = [];

            productData.product_data.product_loyalty_enabled = this.state.loyalty;
            if (this.state.type != "E") {


                for (var i = 0; i < productData.dropdown_mod.length; i++) {


                    if (productData.dropdown_mod[i].modifier_type == "N") {
                        for (var j = 0; j < productData.dropdown_mod[i].options.length; j++) {

                            if (productData.dropdown_mod[i].options[j].option_default == 'Y') {
                                modPrice += productData.dropdown_mod[i].options[j].option_price;
                                modOriginalPrice += productData.dropdown_mod[i].options[j].option_original_price;

                                productData.dropdown_mod[i].mod_value = productData.dropdown_mod[i].options[j].option_name;

                                productData.dropdown_mod[i].options[j].option_selected = "Y";

                            } else {
                                productData.dropdown_mod[i].options[j].option_selected = "N";

                            }
                        }
                    } else {
                        productData.dropdown_mod[i].mod_value = '';
                    }


                }

                /*   for (var i = 0; i < productData.multiselect_mod.length; i++) {


                       for (j = 0; j < productData.multiselect_mod[i].options.length; j++) {

                           if (productData.multiselect_mod[i].options[j].option_default == 'Y') {
                               modPrice += productData.multiselect_mod[i].options[j].option_price;

                               productData.multiselect_mod[i].options[j].option_selected = "Y";

                           } else {
                               productData.multiselect_mod[i].options[j].option_selected = "N";
                           }
                       }


                   }*/

                /*console.log(JSON.stringify(currentArr));*/

                console.log(JSON.stringify(productData.dropdown_mod));

                productData.product_data.modifier_price = modPrice;

                productData.product_data.modifier_original_price = modOriginalPrice;
                this.setState({multiselectList: productData.multiselect_mod});
                this.setState({dropdownList: productData.dropdown_mod});
                this.setState({productData: productData.product_data});

                /*  this.setState({selectedMod: currentArr});*/
                this.setState({showBuildItem: true});
            } else {

                var dbconn = new db();

                dbconn.getAllOrder().then(productDataFromCart => {


                    productDataFromCart.map((item, index) => {

                        if (item.cart_id == sessionStorage.getItem('editCartID')) {


                            for (var i = 0; i < productData.dropdown_mod.length; i++) {

                                if (productData.dropdown_mod[i].modifier_type == "N") {
                                    for (var j = 0; j < productData.dropdown_mod[i].options.length; j++) {

                                        var flag = false;
                                        for (var k = 0; k < item.product_modifiers.length; k++) {


                                            if (item.product_modifiers[k].mod_type == "N") {
                                                if (item.product_modifiers[k].option_id == productData.dropdown_mod[i].options[j].modifier_option_id) {

                                                    productData.dropdown_mod[i].mod_value = item.product_modifiers[k].option_name;
                                                    productData.dropdown_mod[i].options[j].option_selected = item.product_modifiers[k].mod_selected;
                                                    flag = true;
                                                    break;
                                                }
                                            }
                                        }
                                        if (!flag) {
                                            if (productData.dropdown_mod[i].options[j].option_default == "Y" && productData.dropdown_mod[i].modifier_multiselect == "Y") {

                                                productData.dropdown_mod[i].mod_value = productData.dropdown_mod[i].options[j].option_name;
                                                productData.dropdown_mod[i].options[j].option_selected = "Y";
                                            } else {
                                                productData.dropdown_mod[i].options[j].option_selected = "N";
                                            }
                                        }
                                    }
                                } else {

                                    var flag = false;
                                    for (var k = 0; k < item.product_modifiers.length; k++) {
                                        if (item.product_modifiers[k].mod_id == productData.dropdown_mod[i].modifier_id) {
                                            productData.dropdown_mod[i].mod_value = item.product_modifiers[k].option_name;
                                            flag = true;
                                            break;
                                        }
                                    }
                                    if (!flag) {
                                        productData.dropdown_mod[i].mod_value = '';
                                    }

                                }
                            }


                            // alert("hi "+item.product_discount+" "+item.product_discount_type);
                            productData.product_data.product_discount = item.product_discount;
                            productData.product_data.product_discount_type = item.product_discount_type;
                            console.log(productData.product_data);
                            this.setState({multiselectList: productData.multiselect_mod});
                            this.setState({dropdownList: productData.dropdown_mod});
                            this.setState({productData: productData.product_data});
                            this.setState({notes: item.product_notes});

                            this.calculateModifierPrice();
                            this.setState({showBuildItem: true});
                        }
                    });


                });
            }


        }
    };

    createOrder = () => {

        var dbconn = new db();

        var allOkay = true;


        for (var i = 0; i < this.state.dropdownList.length; i++) {

            if (this.state.dropdownList[i].modifier_multiselect == "N") {

                if (this.state.dropdownList[i].modifier_required == "Y" && this.state.dropdownList[i].modifier_type == "N" && $('#' + this.state.dropdownList[i].modifier_id + 'drop').val() == "") {
                    allOkay = false;


                    this.state.swalButton.fire({
                        title: i18n.t('please_select') + " " + ((localStorage.getItem("store_language") === "en") ? this.state.dropdownList[i].modifier_name : (this.state.dropdownList[i]["modifier_name_" + localStorage.getItem("store_language")] !== "") ? this.state.dropdownList[i]["modifier_name_" + localStorage.getItem("store_language")] : this.state.dropdownList[i].modifier_name) + ".",
                        allowOutsideClick: false
                    });
                    break;
                } else if (this.state.dropdownList[i].modifier_required == "Y" && this.state.dropdownList[i].modifier_type == "T" && this.state.dropdownList[i].mod_value == "") {
                    allOkay = false;


                    this.state.swalButton.fire({
                        title: i18n.t('please_enter') + " " + ((localStorage.getItem("store_language") === "en") ? this.state.dropdownList[i].modifier_name : (this.state.dropdownList[i]["modifier_name_" + localStorage.getItem("store_language")] !== "") ? this.state.dropdownList[i]["modifier_name_" + localStorage.getItem("store_language")] : this.state.dropdownList[i].modifier_name) + ".",
                        allowOutsideClick: false
                    });
                    break;
                }
            } else {

                if (this.state.dropdownList[i].modifier_required == "Y" && typeof $('input[name="mod_' + this.state.dropdownList[i].modifier_id + '"]:checked').val() === "undefined") {
                    allOkay = false;

                    this.state.swalButton.fire({
                        title: i18n.t('please_select') + " " + ((localStorage.getItem("store_language") === "en") ? this.state.dropdownList[i].modifier_name : (this.state.dropdownList[i]["modifier_name_" + localStorage.getItem("store_language")] !== "") ? this.state.dropdownList[i]["modifier_name_" + localStorage.getItem("store_language")] : this.state.dropdownList[i].modifier_name) + ".",
                        allowOutsideClick: false
                    });
                    break;
                }
            }
        }


        //  allOkay = true;


        if (allOkay) {


            var productData = this.state.productData;
            productData.product_modifiers = [];

            if (this.state.productData.product_notes_enabled == "Y") {
                productData.product_notes = $('#specialNotes').val();
            } else {
                productData.product_notes = "";
            }

            for (var i = 0; i < this.state.dropdownList.length; i++) {

                if (this.state.dropdownList[i].modifier_type == "N") {

                    for (var j = 0; j < this.state.dropdownList[i].options.length; j++) {

                        if (this.state.dropdownList[i].options[j].option_selected == "Y") {

                            var arr = {};
                            arr.mod_id = this.state.dropdownList[i].modifier_id;
                            arr.mod_type = this.state.dropdownList[i].modifier_type;
                            arr.mod_name = this.state.dropdownList[i].modifier_name;
                            arr.mod_name_es = this.state.dropdownList[i].modifier_name_es;
                            arr.mod_required = this.state.dropdownList[i].modifier_required;


                            arr.option_id = this.state.dropdownList[i].options[j].modifier_option_id;
                            arr.mod_price = this.state.dropdownList[i].options[j].option_price;
                            arr.option_original_price = this.state.dropdownList[i].options[j].option_original_price;
                            arr.mod_default = this.state.dropdownList[i].options[j].option_default;
                            arr.mod_selected = this.state.dropdownList[i].options[j].option_selected;
                            arr.option_name = this.state.dropdownList[i].options[j].option_name;
                            arr.option_name_es = this.state.dropdownList[i].options[j].option_name_es;


                            productData.product_modifiers.push(arr);
                        } else {

                            if (this.state.dropdownList[i].options[j].option_default == "Y" && this.state.dropdownList[i].modifier_multiselect == "Y") {

                                var arr = {};
                                arr.mod_id = this.state.dropdownList[i].modifier_id;
                                arr.mod_type = this.state.dropdownList[i].modifier_type;
                                arr.mod_required = this.state.dropdownList[i].modifier_required;
                                arr.option_id = this.state.dropdownList[i].options[j].modifier_option_id;
                                arr.mod_price = this.state.dropdownList[i].options[j].option_price;
                                arr.option_original_price = this.state.dropdownList[i].options[j].option_original_price;
                                arr.mod_default = this.state.dropdownList[i].options[j].option_default;
                                arr.mod_selected = this.state.dropdownList[i].options[j].option_selected;
                                arr.mod_name = this.state.dropdownList[i].modifier_name;
                                arr.option_name = this.state.dropdownList[i].options[j].option_name;
                                arr.mod_name_es = this.state.dropdownList[i].modifier_name_es;
                                arr.option_name_es = this.state.dropdownList[i].options[j].option_name_es;

                                productData.product_modifiers.push(arr);

                            }

                        }
                    }
                } else {
                    if (this.state.dropdownList[i].mod_value != "") {

                        var arr = {};
                        arr.mod_id = this.state.dropdownList[i].modifier_id;
                        arr.mod_type = this.state.dropdownList[i].modifier_type;
                        arr.mod_name = this.state.dropdownList[i].modifier_name;
                        arr.mod_name_es = this.state.dropdownList[i].modifier_name_es;

                        arr.mod_required = this.state.dropdownList[i].modifier_required;

                        arr.option_id = 0;
                        arr.mod_price = 0;
                        arr.mod_default = "N";
                        arr.option_original_price = 0;

                        arr.mod_selected = "Y";

                        arr.option_name = this.state.dropdownList[i].mod_value;
                        arr.option_name_es = this.state.dropdownList[i].mod_value;


                        productData.product_modifiers.push(arr);
                    }
                }


            }

            console.log(productData);


            this.setState({productData: productData});
            this.addProductToCart();
        }


    };

    addProductToCart = () => {

        var dbconn = new db();
        var cartLength = 0;

        var product = this.state.productData;

        console.log(product);

        dbconn.getAllOrder().then(products => {

            var flag = false;
            var cartItem = 0;


            dbconn.getAllKeys().then(keys => {


                if (keys.length == 0) {
                    cartLength = 0;
                } else {
                    cartLength = Math.max(...keys);
                }

                products.map((item, index) => {


                    if ((parseInt(item.product_id) == parseInt(product.product_id)) && item.product_discount_type != "H" && item.product_discount_type != "G" && (item.product_notes == product.product_notes)) {


                        if (item.product_modifiers.length == product.product_modifiers.length) {

                            var counter = 0;
                            var selectedMod = product.product_modifiers;

                            for (var i = 0; i < selectedMod.length; i++) {

                                for (var j = 0; j < item.product_modifiers.length; j++) {

                                    if (parseInt(selectedMod[i].option_id) == parseInt(item.product_modifiers[j].option_id)) {

                                        if (selectedMod[i].mod_selected == item.product_modifiers[j].mod_selected) {


                                            if (selectedMod[i].option_name == item.product_modifiers[j].option_name) {
                                                console.log(counter);
                                                counter++;
                                            }

                                        }
                                    }
                                }
                            }

                            if (counter == selectedMod.length) {


                                flag = true;
                                cartItem = item;
                            }
                        }
                    }
                });


                if (flag) {

                    console.log("INCREASE QUANTITY");
                    //increase quantity
                    dbconn.deleteOrder(parseInt(cartItem.cart_id)).then(data => {


                        console.log(parseInt(sessionStorage.getItem('editCartID')));
                        console.log(parseInt(cartItem.cart_id));
                        var quantity = 0;
                        if (this.state.type == "E" && flag && parseInt(sessionStorage.getItem('editCartID')) != parseInt(cartItem.cart_id)) {
                            //   alert("A");
                            quantity = parseInt(this.state.quantity) + parseInt(cartItem.product_quantity);
                        } else {

                            if (parseInt(sessionStorage.getItem('editCartID')) != parseInt(cartItem.cart_id)) {
                                quantity = parseInt(this.state.quantity) + parseInt(cartItem.product_quantity);
                                //    alert("B");
                            } else {
                                quantity = parseInt(this.state.quantity);
                                //   alert("C");
                            }

                        }
                        console.log(JSON.stringify({
                            product_name: cartItem.product_name,
                            product_name_es: cartItem.product_name_es,
                            product_desc_es: cartItem.product_desc_es,
                            product_desc: cartItem.product_desc,

                            product_id: cartItem.product_id,
                            product_img: cartItem.product_img,
                            product_quantity: quantity,
                            product_notes: product.product_notes,
                            product_price: cartItem.product_price,
                            product_discount: cartItem.product_discount,
                            product_discount_type: cartItem.product_discount_type,
                            product_modifiers: cartItem.product_modifiers,
                            product_loyalty_enabled: cartItem.product_loyalty_enabled,
                            product_loyalty_price: cartItem.product_loyalty_price,
                            mod_price: cartItem.mod_price,
                            isModifierAvailable: true,
                            cart_id: cartItem.cart_id
                        }));


                        dbconn.setOrder({
                            product_name: cartItem.product_name,
                            product_desc: cartItem.product_desc,
                            product_name_es: cartItem.product_name_es,
                            product_desc_es: cartItem.product_desc_es,
                            product_id: cartItem.product_id,
                            product_img: cartItem.product_img,
                            product_quantity: quantity,
                            product_price: cartItem.product_price,
                            product_original_price: cartItem.product_original_price,
                            product_discount: cartItem.product_discount,
                            product_discount_type: cartItem.product_discount_type,
                            product_notes: product.product_notes,
                            product_modifiers: cartItem.product_modifiers,
                            product_loyalty_enabled: cartItem.product_loyalty_enabled,
                            product_loyalty_price: cartItem.product_loyalty_price,
                            mod_price: cartItem.mod_price,
                            mod_original_price: cartItem.mod_original_price,
                            isModifierAvailable: true,
                            cart_id: cartItem.cart_id
                        }, cartItem.cart_id).then(dat => {

                            if (this.state.type == "E" && flag && parseInt(sessionStorage.getItem('editCartID')) != parseInt(cartItem.cart_id)) {

                                dbconn.deleteOrder(parseInt(sessionStorage.getItem('editCartID'))).then(data => {

                                    sessionStorage.setItem('editCartID', 0);
                                    let myColor = {background: '#0E1717', text: "#FFFFFF"};
                                    notify.show(i18n.t('item_added_cart'), "custom", 2000, myColor);
                                    this.setState({backToHomeFlag: true});
                                    this.calculateCartTotal();
                                });
                            } else {
                                let myColor = {background: '#0E1717', text: "#FFFFFF"};
                                notify.show(i18n.t('item_added_cart'), "custom", 2000, myColor);
                                this.setState({backToHomeFlag: true});
                                this.calculateCartTotal();
                            }


                        });
                    });
                } else {

                    console.log("ADD NEW");
                    if (this.state.type == "E" && this.state.productId == product.product_id) {

                        console.log("EDIT");
                        dbconn.deleteOrder(parseInt(sessionStorage.getItem('editCartID'))).then(data => {


                            console.log(JSON.stringify({
                                product_name: this.state.productData.product_name,
                                product_desc: this.state.productData.product_description,
                                product_name_es: this.state.productData.product_name_es,
                                product_desc_es: this.state.productData.product_description_es,
                                product_id: this.state.productData.product_id,
                                product_img: this.state.productData.product_image,
                                product_quantity: this.state.quantity,
                                product_notes: this.state.productData.product_notes,
                                product_price: this.state.productData.product_price,
                                product_discount: this.state.productData.product_discount,
                                product_discount_type: this.state.productData.product_discount_type,
                                product_modifiers: this.state.productData.product_modifiers,
                                product_loyalty_enabled: this.state.loyalty,
                                product_loyalty_price: this.state.productData.product_loyalty_price,
                                mod_price: this.state.productData.modifier_price,
                                mod_original_price: this.state.productData.modifier_original_price,
                                isModifierAvailable: true,
                                cart_id: cartLength + 1
                            }));
                            dbconn.setOrder({
                                product_name: this.state.productData.product_name,
                                product_desc: this.state.productData.product_description,
                                product_name_es: this.state.productData.product_name_es,
                                product_desc_es: this.state.productData.product_description_es,
                                product_id: this.state.productData.product_id,
                                product_img: this.state.productData.product_image,
                                product_quantity: this.state.quantity,
                                product_notes: this.state.productData.product_notes,
                                product_price: this.state.productData.product_price,
                                product_original_price: this.state.productData.product_original_price,
                                product_discount: this.state.productData.product_discount,
                                product_discount_type: this.state.productData.product_discount_type,
                                product_modifiers: this.state.productData.product_modifiers,
                                product_loyalty_enabled: this.state.loyalty,
                                product_loyalty_price: this.state.productData.product_loyalty_price,
                                mod_price: this.state.productData.modifier_price,
                                mod_original_price: this.state.productData.modifier_original_price,
                                isModifierAvailable: true,
                                cart_id: cartLength + 1
                            }, cartLength + 1).then(dat => {

                                sessionStorage.setItem('editCartID', 0);
                                let myColor = {background: '#0E1717', text: "#FFFFFF"};
                                notify.show(i18n.t('item_added_cart'), "custom", 2000, myColor);
                                this.setState({backToHomeFlag: true});
                                this.calculateCartTotal();
                            });
                        });
                    } else {


                        var couponType = sessionStorage.getItem("couponType");

                        var couponDiscount = 0;

                        if (couponType && (couponType == "E" || couponType == "J" || couponType == "K")) {

                            var couponproduct = JSON.parse(sessionStorage.getItem("couponProductDetails"))

                            var count = 0;
                            for (var i = 0; i < couponproduct.length; i++) {

                                for (var j = 0; j < products.length; j++) {
                                    if (products[j].product_id == couponproduct[i].product_id && products[j].product_loyalty_enabled == "N" && couponproduct[i].coupon_details_type == "Q") {

                                        count++;
                                    }
                                }
                                if (product.product_id == couponproduct[i].product_id && product.product_loyalty_enabled == "N" && couponproduct[i].coupon_details_type == "Q") {
                                    count++;
                                }
                            }


                            if (count == couponproduct.length) {
                                couponDiscount = sessionStorage.getItem("couponDiscount");
                                if (couponType == "J") {
                                    couponType = "A";
                                } else {
                                    couponType = "P";
                                }
                            } else {
                                couponType = "";
                            }

                        } else {
                            couponType = "";
                        }


                        console.log("NEW");
                        console.log(JSON.stringify({
                            product_name: this.state.productData.product_name,
                            product_desc: this.state.productData.product_description,
                            product_name_es: this.state.productData.product_name_es,
                            product_desc_es: this.state.productData.product_description_es,
                            product_id: this.state.productData.product_id,
                            product_img: this.state.productData.product_image,
                            product_quantity: this.state.quantity,
                            product_notes: this.state.productData.product_notes,
                            product_price: this.state.productData.product_price,
                            product_discount: couponDiscount,
                            product_discount_type: couponType,
                            product_modifiers: this.state.productData.product_modifiers,
                            product_loyalty_enabled: this.state.loyalty,
                            product_loyalty_price: this.state.productData.product_loyalty_price,
                            mod_price: this.state.productData.modifier_price,
                            mod_original_price: this.state.productData.modifier_original_price,
                            isModifierAvailable: true,
                            cart_id: cartLength + 1
                        }));
                        dbconn.setOrder({
                            product_name: this.state.productData.product_name,
                            product_desc: this.state.productData.product_description,
                            product_name_es: this.state.productData.product_name_es,
                            product_desc_es: this.state.productData.product_description_es,
                            product_id: this.state.productData.product_id,
                            product_img: this.state.productData.product_image,
                            product_quantity: this.state.quantity,
                            product_notes: this.state.productData.product_notes,
                            product_price: this.state.productData.product_price,
                            product_original_price: this.state.productData.product_original_price,
                            product_discount: couponDiscount,
                            product_discount_type: couponType,
                            product_modifiers: this.state.productData.product_modifiers,
                            product_loyalty_enabled: this.state.loyalty,
                            product_loyalty_price: this.state.productData.product_loyalty_price,
                            mod_price: this.state.productData.modifier_price,
                            mod_original_price: this.state.productData.modifier_original_price,
                            isModifierAvailable: true,
                            cart_id: cartLength + 1
                        }, cartLength + 1).then(dat => {


                            let myColor = {background: '#0E1717', text: "#FFFFFF"};
                            notify.show(i18n.t('item_added_cart'), "custom", 2000, myColor);
                            this.setState({backToHomeFlag: true});
                            this.calculateCartTotal();
                        });
                    }
                }
            });
        });
    };


    calculateCartTotal = () => {

        var dbconn = new db();

        var cartTotal = 0;

        dbconn.getAllOrder().then(products => {


            var couponType = sessionStorage.getItem("couponType");
            if (couponType && couponType == "H") {
                dbconn.deleteAllCouponOrder("H").then(db1 => {
                    dbconn.getAllKeys().then(keys => {

                        var cartLength = 0;
                        if (keys.length == 0) {
                            cartLength = 0;
                        } else {
                            cartLength = Math.max(...keys);
                        }

                        var couponProducts = JSON.parse(sessionStorage.getItem("couponProductDetails"));
                        console.log(products);

                        var productArray = JSON.parse(JSON.stringify(products));
                        for (var i = 0; i < products.length; i++) {

                            for (var j = 0; j < couponProducts.length; j++) {


                                if (products[i].product_id == couponProducts[j].product_id && products[i].product_loyalty_enabled == "N" && couponProducts[j].coupon_details_type == "Q") {

                                    cartLength++;
                                    products[i].product_discount = sessionStorage.getItem("couponDiscount");
                                    products[i].product_discount_type = "H";
                                    products[i].cart_id = cartLength;

                                    productArray.push(products[i]);
                                    var dbconn = new db();
                                    dbconn.setOrder(products[i], cartLength).then(data => {

                                    });


                                }


                            }

                        }


                        productArray.map((item, index) => {

                            if (item.product_loyalty_enabled == "N") {

                                var discount = 0;
                                if (item.product_discount_type == "P" || item.product_discount_type == "H" || item.product_discount_type == "G") {

                                    discount = ((parseFloat(item.product_price) + parseFloat(item.mod_price)) * parseFloat(item.product_discount)) / 100;

                                } else if (item.product_discount_type == "A") {
                                    discount = parseFloat(item.product_discount);
                                }

                                cartTotal += (((parseFloat(item.product_price) + parseFloat(item.mod_price)) - discount) * parseInt(item.product_quantity));
                                //  cartTotal += ((parseFloat(item.product_price) + parseFloat(item.mod_price)) * parseInt(item.product_quantity));
                            } else {
                                cartTotal += (parseFloat(item.mod_price) * parseInt(item.product_quantity));
                            }
                        });

                        sessionStorage.setItem('cartTotal', cartTotal);
                        this.setState({cartTotal: cartTotal});


                    });
                });
            } else {
                products.map((item, index) => {

                    if (item.product_loyalty_enabled == "N") {

                        var discount = 0;
                        if (item.product_discount_type == "P" || item.product_discount_type == "H" || item.product_discount_type == "G") {

                            discount = ((parseFloat(item.product_price) + parseFloat(item.mod_price)) * parseFloat(item.product_discount)) / 100;

                        } else if (item.product_discount_type == "A") {
                            discount = parseFloat(item.product_discount);
                        }

                        cartTotal += (((parseFloat(item.product_price) + parseFloat(item.mod_price)) - discount) * parseInt(item.product_quantity));
                        //  cartTotal += ((parseFloat(item.product_price) + parseFloat(item.mod_price)) * parseInt(item.product_quantity));
                    } else {
                        cartTotal += (parseFloat(item.mod_price) * parseInt(item.product_quantity));
                    }
                });

                sessionStorage.setItem('cartTotal', cartTotal);
                this.setState({cartTotal: cartTotal});
            }


        });
    };

    componentDidMount() {
        var height = $(window).height();
        this.setState({windowHeight: height});

        document.title = "View Product - " + localStorage.getItem("store_name") + " - Tria Commerce";


        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }
        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }

        var backUrl = "";


        if (this.state.type == "A") {
            if (this.state.loyalty == "Y") {
                this.setState({backUrl: "/rewards"});
            } else {
                this.setState({backUrl: "/menu"});
            }
        } else {
            this.setState({backUrl: "/order/view"});

        }

    }

    logout = () => {

        var dbconn = new db();

        dbconn.deleteAll();
        dbconn.deleteAllOrder();
        localStorage.removeItem("remember");

        this.setState({nosessionredirect: true});
    };

    openNav = () => {
        $("#mySidenav").addClass('fullWidth');


    };

    closeNav = () => {
        $("#mySidenav").removeClass('fullWidth');

    };

    render(resize = "vertical") {

        const {open} = this.state;
        const {t} = this.props;
        if (this.state.nosessionredirect) {
            return (<Redirect to={'/'}/>);
        }

        if (this.state.backToHomeFlag) {
            return (<Redirect to={'/menu'}/>);
        }

        var productWidth = "";

        if (this.state.productData.product_image != "") {
            productWidth = "col-md-9 col-sm-7 col-xs-7";
        } else {
            productWidth = "col-md-12 col-sm-12 col-xs-12";
        }

        return (
            <div className="mainContainer">


                <header className="okayNav-header">
                    <div className="col-md-12 col-sm-12 col-xs-12  previous-link">

                        <Link to={this.state.backUrl}></Link>

                        <h2 className="text-center" style={{paddingTop: "10px"}}>{t('product_details')}</h2>


                    </div>

                </header>

                <div className="mt-white h-100 " style={{position: "fixed", width: "100%"}}>
                    <div className="simple-box m-b-0 p-b-35 bkg-white middleContent"
                         style={{padding: "0px", height: "100vh", overflowY: "scroll", paddingBottom: "150px"}}>
                        <div className="form-box div-center">

                            <div className="clearfix"></div>
                            <div className="p-t-55" style={{paddingTop: "10px"}}>

                                {(this.state.showBuildItem) ?
                                    <div key={this.state.productData.product_id}
                                         className="product-main-block">
                                        <div className="simple-box simple-box-w-100 m-b-0">
                                            <div className="product-block">
                                                {(this.state.productData.product_image != "") ?
                                                    <div className="col-md-3 col-sm-5 col-xs-5">
                                                        <div className="row">
                                                            <div className="product-img">
                                                                <img
                                                                    id={'product_image_' + this.state.productData.product_id}
                                                                    src={IMAGE_ROOT + "/images/product/" + this.state.productData.product_image}
                                                                    alt="Product Image"/>
                                                            </div>
                                                        </div>
                                                    </div> : ''}


                                                <div className={productWidth}>
                                                    <div className="product-info">
                                                        <h4 id={'product_name_' + this.state.productData.product_id}> {(localStorage.getItem("store_language") === "en") ? this.state.productData.product_name : (this.state.productData["product_name_" + localStorage.getItem("store_language")] !== "") ? this.state.productData["product_name_" + localStorage.getItem("store_language")] : this.state.productData.product_name} </h4>
                                                        <div className="product-price float_l m-t-5 m-r-10"
                                                             style={{paddingRight: '20px'}}>

                                                            {(this.state.loyalty == "N") ?
                                                                <p className="text-left"
                                                                   id={'price_' + this.state.productData.product_id}>$ {((parseFloat(this.state.productData.product_price) + parseFloat(this.state.productData.modifier_price)) * this.state.quantity).toFixed(2)} </p>
                                                                : <p className="text-left"
                                                                     id={'price_' + this.state.productData.product_id}> {parseFloat(this.state.productData.product_loyalty_price) * this.state.quantity} Points </p>}
                                                        </div>
                                                        {(this.state.loyalty == "N" && this.state.productData.product_discount_type != "G") ?


                                                            <div className="input-group">
                                                                <span className="input-group-btn">
                                                      <button type="button"
                                                              id={"btn-minus_" + this.state.productData.product_id}
                                                              name={"btn-minus_" + this.state.productData.product_id}
                                                              onClick={() => {
                                                                  this.lessQuantity(this.state.productData.product_id)
                                                              }} className="btn-number" data-type="minus"
                                                              data-field="quant[2]">
                                                        <span className="quty-icon minus-icon">-</span>
                                                      </button>
                                                  </span>
                                                                <input type="text" disabled={true} readOnly={true}
                                                                       id={"quant_" + this.state.productData.product_id}
                                                                       name={"quant_" + this.state.productData.product_id}
                                                                       className="form-control input-number"
                                                                       min="1" max="99"
                                                                       defaultValue={this.state.quantity}/>
                                                                <span className="input-group-btn">
                                                      <button type="button"
                                                              id={"btn-plus_" + this.state.productData.product_id}
                                                              name={"btn-plus_" + this.state.productData.product_id}
                                                              onClick={() => {
                                                                  this.plusQuantity(this.state.productData.product_id)
                                                              }} className="btn-number" data-type="plus"
                                                              data-field="quant[2]">
                                                          <span className="quty-icon plus-icon">+</span>
                                                      </button>
                                                  </span>
                                                            </div>
                                                            : ""}

                                                    </div>


                                                </div>
                                                <div className="col-lg-12 col-sm-12 col-md-12"
                                                     style={{padding: "10px", textAlign: "justify"}}>
                                                    <div className="product-content p-t-10 p-b-10">
                                                        <p className="text-left"> {(localStorage.getItem("store_language") === "en") ? this.state.productData.product_description : (this.state.productData["product_description_" + localStorage.getItem("store_language")] !== "") ? this.state.productData["product_description_" + localStorage.getItem("store_language")] : this.state.productData.product_description}  </p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div>
                                            <div className="product-extra-block modifierBlock clearfix"
                                                 style={{marginBottom: "50px", paddingBottom: "20px"}}>
                                                <div className="extra-block-header">
                                                    <div className="simple-box m-b-0 simple-box-w-100">
                                                        <h4 className="m-0 color_white w">{t('customize_item')}</h4>
                                                    </div>
                                                </div>


                                                {this.state.dropdownList.map((dropItem, index) => {


                                                    if (dropItem.modifier_multiselect != "Y") {

                                                        var required = (dropItem.modifier_required == "Y") ? true : false;

                                                        if (dropItem.modifier_type == "N") {

                                                            var selectedOpt = 0;
                                                            var labelTxt = '';


                                                            dropItem.options.map((option, index) => {
                                                                if (option.option_selected == "Y") {
                                                                    selectedOpt = option.modifier_option_id;
                                                                    labelTxt = option.option_name;

                                                                }
                                                            });


                                                            return (<div key={dropItem.modifier_id}
                                                                         className="extra-block-content grey-select">
                                                                <div className="simple-box m-b-0 simple-box-w-100">
                                                                    <div className="form-group">
                                                        <span
                                                            style={{fontSize: "18px"}}>{(localStorage.getItem("store_language") === "en") ? dropItem.modifier_name : (dropItem["modifier_name_" + localStorage.getItem("store_language")] !== "") ? dropItem["modifier_name_" + localStorage.getItem("store_language")] : dropItem.modifier_name} {(required) ? '(' + t('required') + ')' : ''} </span>
                                                                        <span style={{marginTop: "10px"}}
                                                                              className=" form-group">



                                                                        <select id={dropItem.modifier_id + "drop"}
                                                                                name={dropItem.modifier_id}
                                                                                className="form-control custom-select modifierSelect radius-0"
                                                                                required={required}
                                                                                defaultValue={selectedOpt}
                                                                                onChange={this.updateLabel}>
                                                                            <option
                                                                                value=''>{t('choose_your')} {(localStorage.getItem("store_language") === "en") ? dropItem.modifier_name : (dropItem["modifier_name_" + localStorage.getItem("store_language")] !== "") ? dropItem["modifier_name_" + localStorage.getItem("store_language")] : dropItem.modifier_name}</option>
                                                                            {dropItem.options.map((optionObj, index) => {


                                                                                return (<option
                                                                                    key={optionObj.modifier_option_id}
                                                                                    id={optionObj.modifier_option_id}
                                                                                    value={optionObj.modifier_option_id}
                                                                                    data-price={optionObj.option_price}
                                                                                    data-default={optionObj.option_default}
                                                                                    data-option={optionObj.option_name}
                                                                                    data-modifier={dropItem.modifier_name}>{(localStorage.getItem("store_language") === "en") ? optionObj.option_name : (optionObj["option_name_" + localStorage.getItem("store_language")] !== "") ? optionObj["option_name_" + localStorage.getItem("store_language")] : optionObj.option_name}   </option>);
                                                                            })}
                                                                        </select>

                                                                    </span>
                                                                    </div>
                                                                </div>
                                                            </div>);
                                                        } else {

                                                            return (<div key={dropItem.modifier_id}
                                                                         className="extra-block-content">
                                                                <div>
                                                                    <div className="simple-box m-b-0 simple-box-w-100">
                                                                        <div className="label_title"
                                                                             style={{
                                                                                 width: "100%",
                                                                                 marginBottom: "10px"
                                                                             }}>
                                        <span
                                            style={{fontSize: "18px"}}>{(localStorage.getItem("store_language") === "en") ? dropItem.modifier_name.toUpperCase() : (dropItem["modifier_name_" + localStorage.getItem("store_language")] !== "") ? dropItem["modifier_name_" + localStorage.getItem("store_language")].toUpperCase() : dropItem.modifier_name.toUpperCase()} {(dropItem.modifier_required == "Y") ? '(' + t('required') + ')' : ''}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="extra-block-content grey-select"
                                                                     style={{paddingLeft: '0px', paddingTop: '0px'}}>
                                                                    < div className="simple-box m-b-0 simple-box-w-100">
                                                                        <div className="form-group">

                                            <textarea maxLength="100" className="form-control"
                                                      rows="2" style={{resize: resize}}
                                                      onKeyUp={this.updateModifierText}
                                                      id={dropItem.modifier_id}
                                                      name={'mod_' + dropItem.modifier_id}
                                                      defaultValue={dropItem.mod_value}
                                                      data-modifier={dropItem.modifier_name}></textarea>


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>);
                                                        }

                                                    } else {

                                                        var required = (dropItem.modifier_required == "Y") ? true : false;

                                                        var selectedOpt = 0;


                                                        return (
                                                            <div key={dropItem.modifier_id}
                                                                 className="extra-block-content">
                                                                <div className="simple-box m-b-0 simple-box-w-100">
                                                                    <div className="label_title"
                                                                         style={{width: "100%", marginBottom: "10px"}}>
                                        <span
                                            style={{fontSize: "18px"}}>{(localStorage.getItem("store_language") === "en") ? dropItem.modifier_name.toUpperCase() : (dropItem["modifier_name_" + localStorage.getItem("store_language")] !== "") ? dropItem["modifier_name_" + localStorage.getItem("store_language")].toUpperCase() : dropItem.modifier_name.toUpperCase()} {(dropItem.modifier_required == "Y") ? '(' + t('required') + ')' : ''}</span>
                                                                    </div>
                                                                    {dropItem.options.map((optionObj, index) => {


                                                                        /*if (this.state.type == "E") {
                                                                            this.state.selectedOptions.map((option, index) => {
                                                                                if (option.option_id == optionObj.modifier_option_id) {
                                                                                    selectedOpt = option.option_id;
                                                                                }
                                                                            });
                                                                        }*/


                                                                        var checked = (optionObj.option_selected == 'Y') ? true : false;


                                                                        return (
                                                                            <div key={optionObj.modifier_option_id}>
                                                                                <div className="form-group clear">
                                                                                    <label
                                                                                        htmlFor={'opt_' + optionObj.modifier_option_id}
                                                                                        className="ch_boxModifier font-family-bold">{(localStorage.getItem("store_language") === "en") ? optionObj.option_name.toUpperCase() : (optionObj["option_name_" + localStorage.getItem("store_language")] !== "") ? optionObj["option_name_" + localStorage.getItem("store_language")].toUpperCase() : optionObj.option_name.toUpperCase()}
                                                                                        <input type="checkbox"
                                                                                               className="form-control"
                                                                                               onChange={this.calTotalMultiselectPrice}
                                                                                               id={'opt_' + optionObj.modifier_option_id}
                                                                                               name={'mod_' + dropItem.modifier_id}
                                                                                               value={optionObj.modifier_option_id}
                                                                                               style={{display: "none"}}
                                                                                               data-price={optionObj.option_price}
                                                                                               data-default={optionObj.option_default}
                                                                                               data-modifier={dropItem.modifier_name}
                                                                                               data-option={optionObj.option_name}
                                                                                               defaultChecked={checked}/>
                                                                                        <span
                                                                                            className="checkMarkPrice">{(parseFloat(optionObj.option_price) > 0) ? '$' + optionObj.option_price.toFixed(2) : ''}</span><span
                                                                                            className="checkmarkModifier"></span>
                                                                                    </label>
                                                                                </div>
                                                                                <hr style={{
                                                                                    marginTop: "20px",
                                                                                    marginBottom: "20px",
                                                                                    marginLeft: "0px",
                                                                                    width: "100%"
                                                                                }}/>
                                                                            </div>);


                                                                    })}
                                                                </div>
                                                            </div>);
                                                    }
                                                })}


                                                {(this.state.productData.product_notes_enabled == "Y") ? (
                                                    <div className="extra-block-header">
                                                        <div>
                                                            <div className="simple-box m-b-0 simple-box-w-100">
                                                                <h4 className="m-0 color_white w">{t('special_notes')}</h4>
                                                            </div>
                                                        </div>
                                                        <div className="extra-block-content grey-select"
                                                             style={{paddingLeft: '0px'}}>
                                                            < div className="simple-box m-b-0 simple-box-w-100">
                                                                <div className="form-group">

                                            <textarea maxlength="100" className="form-control"
                                                      defaultValue={this.state.notes}
                                                      rows="2" style={{resize: resize}}
                                                      id="specialNotes"></textarea>


                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>) : ''}
                                            </div>
                                        </div>


                                    </div>
                                    : ""}


                            </div>


                            <input type="button" className="form-control bkg-purple-btn centerButton font"
                                   name="addToOrderBtn" id="addToOrderBtn"
                                   onClick={() => {
                                       this.createOrder()
                                   }} style={{position: "fixed", bottom: "0", height: "45px"}}
                                   value={t('add_to_cart')}/>
                        </div>
                    </div>
                </div>

                <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false} open={open}
                       onClose={this.onCloseModal} center>
                    <h2>&nbsp;&nbsp;&nbsp;&nbsp;{t('loading')}...&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                    <p style={{textAlign: 'center'}}>
                        <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                    </p>
                </Modal>


                <Notifications options={{zIndex: 9999, width: '100%', top: '50px'}}/>
                <Language/>
                <div className="clearfix"></div>
            </div>
        );
    }
}

export default withRouter(withTranslation()(view_product));



// WEBPACK FOOTER //
// ./src/view_components/view_product.js